import {FullPageSpinner} from "../../components/loading/Spinner";
import {FC, useEffect} from "react";
import {useGoogleAuthUri} from "./useGoogleAuthUri";
import {Navigate} from "react-router-dom";
import {useParams} from "react-router";
import {IntegrationApp, isValidIntegrationApp} from "./app-names";
import {useMicrosoftAuthUri} from "./useMicrosoftAuthUri";

export const PreAuthPage: FC = () => {
 const params = useParams();
 const appName = (params.app_name || "") as IntegrationApp;
 const searchParams = new URLSearchParams(window.location.search);
 const prompt = searchParams.get("prompt") || "";
 const openerURI = searchParams.get("opener_uri") || "";
 if (!openerURI || !isValidIntegrationApp(appName)) {
     return <Navigate to="/error"/>
 }

  useEffect(() => {
   if (appName === IntegrationApp.GoogleDrive) {
    window.location.assign(useGoogleAuthUri(openerURI, prompt).googleDriveAuthUri)
    return
   }
   if (appName === IntegrationApp.OneDrive) {
    window.location.assign(useMicrosoftAuthUri(openerURI, prompt).oneDriveAuthUri)
    return
   }
  }, []);

  return <FullPageSpinner/>;
};
